export default __webpack_public_path__ + "static/insta3-4c9cfa113fb8e578c5793fd1095141bd.jpg";